import ClientInvoiceAssignmentSearchParams from '../Contents/Operations/ClientInvoiceAdmin/Details/ClientInvoiceAssignmentSearchParams';
import ClientInvoiceLineItemSearchParams from '../Contents/Operations/ClientInvoiceAdmin/Details/ClientInvoiceLineItemSearchParams';

export default class ApplyTpPaymentItem {
  constructor() {
    this.AllItemsInTheSearchAreSelected = false;
    this.NumberOfItemsSelected = 0;
    this.LineItemIds = [];
    this.TpClientInvoiceIds = [];
    this.TpClientInvoiceId = 0;
    this.TpClientPaymentId = 0;
    this.InvoiceType = '';
    this.LineItemSearchParams = new ClientInvoiceLineItemSearchParams();
    this.AssignmentSearchParams = new ClientInvoiceAssignmentSearchParams();
    this.AmountApplied = 0;
    this.TypeOfDistribution = '';
  }
}
